export class RoutePaths {
  private constructor() {}

  public static loginPage(): string {
    return '/login';
  }

  public static forgotPassword(): string {
    return '/forgotPassword';
  }

  public static resetPassword(token: string): string {
    return `/resetPassword/${token}`;
  }

  public static home(): string {
    return '/home';
  }

  public static createWorkTimeEntry(): string {
    return '/trackedWorkTime/create';
  }

  public static createWorkTimeEntrySelectActivity(
    parentActivityId?: string | null
  ): string {
    if (parentActivityId == null) {
      return '/trackedWorkTime/create/selectActivity';
    }

    return `/trackedWorkTime/create/selectActivity/${parentActivityId}`;
  }

  public static createWorkTimeEntrySelectConstructionSite(): string {
    return '/trackedWorkTime/create/selectConstructionSite';
  }

  public static createWorkTimeEntryCreateConstructionSite(): string {
    return '/trackedWorkTime/create/createConstructionSite';
  }

  public static myWorkTimeOverview(): string {
    return '/trackedWorkTime/overview';
  }

  public static adminWorkTime(userGroupId: string, userId: string): string {
    return `/trackedWorkTime/admin/${userGroupId}/${userId}`;
  }

  public static editWorkTimeEntry(workTimeEntryId: string): string {
    return `/trackedWorkTime/edit/${workTimeEntryId}`;
  }

  public static adminTimeTrackingConfigurations(): string {
    return '/administration/timeTrackingConfigurations';
  }

  public static adminTimeTrackingActivityCompilations(
    userGroupId: string
  ): string {
    return `/administration/timeTrackingActivityCompilations/${userGroupId}`;
  }

  public static adminTimeTrackingActivities(
    compilationId: string,
    parentActivityId?: string | null
  ): string {
    if (parentActivityId == null) {
      return `/administration/timeTrackingActivities/${compilationId}`;
    }

    return `/administration/timeTrackingActivities/${compilationId}/${parentActivityId}`;
  }

  public static adminConstructionSites(): string {
    return '/administration/constructionSites';
  }

  public static adminConstructionSitesCreateConstructionSite(
    userGroupId: string
  ): string {
    return `/administration/constructionSites/create/${userGroupId}`;
  }

  public static adminUsers(): string {
    return '/administration/users';
  }

  public static adminUserGroups(): string {
    return '/administration/usergroups';
  }
}
